import {useParams} from 'react-router-dom';

import {Header, Tabs} from '@/components';
import {useAppRates} from '@/context/AppRatesContext';
import type {TabItem} from '@/types';

import TierRateTable from './TierRateTable';
import TierSummary from './TierSummary';
import TierTransactionList from './TierTransactionList';
import TierUserList from './TierUserList';
import useTierDetails from './useTierDetails';

const TierDetails = () => {
  const params = useParams();
  const tierId = params?.tierId || '';
  const {tier, isLoading} = useTierDetails(tierId);
  const {state} = useAppRates();

  // `userTotal` / `transactionTotal` live under `meta.stats` on the
  // `AfriexRatePromo` this endpoint returns; reading them off the root left
  // both labels permanently empty.
  const {userTotal, transactionTotal} = tier.meta?.stats ?? {};
  const userCountLabel = userTotal ? ` (${userTotal.toLocaleString()})` : '';
  const transactionCountLabel = transactionTotal
    ? ` (${transactionTotal.toLocaleString()})`
    : '';

  const tabs: TabItem[] = [
    {
      id: 'details',
      title: 'Details',
      content: (
        <TierSummary
          isDetail
          isLoading={isLoading}
          item={tier}
          rawAppRates={state.rawAppRates}
        />
      ),
    },
    {
      id: 'rates',
      title: 'Rates',
      content: (
        <TierRateTable
          loading={isLoading}
          rawAppRates={state.rawAppRates}
          discount={tier.discount}
        />
      ),
    },
    {id: 'users', title: 'Users' + userCountLabel, content: <TierUserList />},
    {
      id: 'transactions',
      title: 'Transactions' + transactionCountLabel,
      content: <TierTransactionList />,
    },
  ];
  return (
    <div>
      <Header title={tier?.name || ''} />
      <Tabs key={isLoading?.toString()} tabs={tabs} queryKey={'tab'} />
    </div>
  );
};
export default TierDetails;
